<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-discipline-disciplinary-action-dialog-create
          v-if="$hasPermissionTo(['create disciplinary actions'])"
          @created="loadData"
        />
      </v-col>
      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-select
          v-model="statusFilter"
          :items="items"
          item-text="state"
          item-value="value"
          label="Discipline Action's Status"
          placeholder="Active / Deleted"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in disciplinary action here"
          append-icon="search"
          label="Search Disciplinary Actions"
          hide-no-data
          hide-selected
        />
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="filteredDisciplinaryActions"
      :loading="tableLoading"
      :search="search"
    >
      <template v-slot:item.action="{ item }">
        <span v-if="statusFilter">
          <setup-discipline-disciplinary-action-dialog-edit
            v-if="$hasPermissionTo(['update disciplinary actions'])"
            :disciplinary-action="item"
            @updated="loadData"
          />
          <span class="mx-1" />
          <setup-discipline-disciplinary-action-dialog-delete
            v-if="$hasPermissionTo(['delete disciplinary actions'])"
            :disciplinary-action="item"
            @deleted="loadData"
          />
        </span>
        <span v-else>
          <setup-discipline-disciplinary-action-dialog-restore
            v-if="$hasPermissionTo(['restore disciplinary actions'])"
            :disciplinary-action="item"
            @restored="loadData"
          />
        </span>
      </template> 
    </v-data-table>
  </div>
</template>

<script>
  export default {
    components: {
      SetupDisciplineDisciplinaryActionDialogCreate: () => import('@/components/hris/setup/disciplines/disciplinary-action/DialogCreate'),
      SetupDisciplineDisciplinaryActionDialogDelete: () => import('@/components/hris/setup/disciplines/disciplinary-action/DialogDelete'),
      SetupDisciplineDisciplinaryActionDialogRestore: () => import('@/components/hris/setup/disciplines/disciplinary-action/DialogRestore'),
      SetupDisciplineDisciplinaryActionDialogEdit: () => import('@/components/hris/setup/disciplines/disciplinary-action/DialogEdit'),
    },
    data () {
      return {
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        headers: [
          {
            text: 'Disciplinary Action',
            align: 'left',
            value: 'name',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        tableLoading: true,
        disciplinaryActions: [],
        trashedDisciplinaryActions: [],
      }
    },
    computed: {
      filteredDisciplinaryActions () {
        return this.statusFilter ? this.disciplinaryActions : this.trashedDisciplinaryActions
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        Promise.all([
          this.$api.disciplinaryActions().list(),
          this.$api.disciplinaryActions().listTrashed(),
        ]).then(([disciplineAction, trashedDisciplineAction]) => {
          this.disciplinaryActions = disciplineAction.data
          this.trashedDisciplinaryActions = trashedDisciplineAction.data

          this.tableLoading = false
        })
      },
    },
  }
</script>
